export default "__VITE_ASSET__Ca0RJ_u7__"